import jQuery from 'jquery';
import * as bootstrap from 'bootstrap';
import L from 'leaflet';

window.jQuery = window.$ = jQuery;
window.bootstrap = bootstrap;
window.L = L;
